/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ kg: NonNullable<unknown> }} Features_Hero_Chip_RecordInputs */

const en_features_hero_chip_record = /** @type {(inputs: Features_Hero_Chip_RecordInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`New best: ${i?.kg} kg`)
};

const pl_features_hero_chip_record = /** @type {(inputs: Features_Hero_Chip_RecordInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nowy rekord: ${i?.kg} kg`)
};

/**
* | output |
* | --- |
* | "New best: {kg} kg" |
*
* @param {Features_Hero_Chip_RecordInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_hero_chip_record = /** @type {((inputs: Features_Hero_Chip_RecordInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Hero_Chip_RecordInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_hero_chip_record(inputs)
	return en_features_hero_chip_record(inputs)
});